import { FaLinkedinIn } from "react-icons/fa";
import ceoAffan from "../../../../assets/images/affan.avif";

function AuthorLayout() {
  return (
<aside aria-label="Author information">
      <div className="bg[rgba(255,255,255,0.05)] backdrop-blur-[5px] bg--100 border border-[rgba(255,255,255,0.3)] rounded-[10px] [border-image-source:radial-gradient(81.59%_81.59%_at_18.48%_100%,_#FFFFFF_0%,_rgba(255,255,255,0)_100%),_radial-gradient(88.88%_88.88%_at_4.11%_6.2%,_#FFFFFF_0%,_rgba(255,255,255,0)_100%)] [border-image-slice:1] flex flex-col md:flex-row justify-start items-start space-y-5 md:space-y-0 md:space-x-6 py-10  ">
        <div className="w-36 rounded-md overflow-hidden  h[9rem]">
          <img src={ceoAffan} alt="picture of the author" width={20} height={20} className="h-full" />
        </div>
        <div className="space-y-4 ">
          <div>
            <div className="  space-x1">
              <h2 className="text-dark text-xl md:text-2xl font-bold">
                Author {""}
              </h2>
              <h3 className="text-dark text-lg md:text-xl">
                Affan Salim
              </h3>
            </div>
            <p className="text-dark text-lg md:text-xl ">
              Chief Technology Officer
            </p>
          </div>
          <div className="flex">
            <a
              href="https://pk.linkedin.com/in/affan-salim-51ba3524a"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-200 px-2 md:px-2 py-2 md:py-2 rounded text-lg  transition-all duration-300 ease-in  hover:bg-[#FFC067] "
              aria-label="Link of LinkedIn profile of the author"
              title="Link of LinkedIn profile of the author"
            >
              <FaLinkedinIn className="text-sm"/>
            </a>
          </div>
        </div>
      </div>
</aside>
  );
}

export default AuthorLayout;
